<template>
  <div class="my_vote_list">
    <!-- 头部开始 -->
    <topPart :rightPart="true"></topPart>
    <!-- 头部结束 -->
    <!-- 列表按钮 -->
    <div class="list-block-list">
      <van-tabs
        v-infinite-scroll="loadMore"
        infinite-scroll-distance="50"
        class="list-block"
        v-model="activeTab"
        sticky
        @click="tabClick(true)"
      >
        <van-tab v-for="item in tabList" :title="item.label" :key="item.key">
          <!-- 列表 -->
          <div>
            <!-- 循环列表 -->
            <div
              class="card-box"
              v-for="(items,index) in tabList[activeTab].list"
              :key="index"
              @click="detailsOfSympathy(items)"
            >
              <!-- title栏 -->
              <div class="title-box1">
                <!--类型  -->
                <div class="titleStyle">提案</div>
                <!-- 类型结束 -->
                <!-- 标题 -->
                <div class="nameStyle">{{items.title}}</div>
                <!-- 标题结束 -->
              </div>
              <!-- 内容 -->
              <div class="conterStyle" v-html="items.content"></div>
              <!-- 内容结束 -->
              <!-- 状态按钮 -->
              <div class="stateStyle">
                <span :class="getStatusColor(items,item.list)">{{getStatus(items)}}</span>
              </div>
              <!-- 状态按钮 -->
              <!-- title栏结束 -->
            </div>
            <!-- 循环列表结束 -->
          </div>
          <!-- 列表结束 -->
        </van-tab>
      </van-tabs>
    </div>
    <!-- 列表按钮结束 -->
  </div>
</template>

<script>
import topPart from "../../../components/topPart";
export default {
  components: {
    topPart,
  },
  created() {
    // this.tabClick();
  },
  methods: {
    //重置页码
    resect() {
      this.currentPage = 1; //第几页
      this.pageSize = 10; //每页展示数量
    },
    //点击事件
    tabClick(flag) {
      if (flag) {
        this.resect();
      }
      var obj = this.getTabsConfig();
      this.getMemberList(obj.url);
    },
    //获取配置
    getTabsConfig() {
      return this.tabList[this.activeTab];
    },
    detailsOfSympathy(obj) {
      var item = this.getTabsConfig();
      this.$router.push({
        path: item.router,
        query: {
          signatureId: obj.signatureId,
          sign: obj.isSignature,
          id: obj.id,
          recordId: obj.recordId,
          subStatusp: obj.subStatusp,
        },
      });
    },
    //获取状态
    getStatus(item) {
      var obj = this.getTabsConfig();
      return this[obj.configKey][item.subStatusp].title;
    },
    //下拉刷新
    loadMore() {
      this.currentPage = this.currentPage + 1;
      this.tabClick();
    },
    //列表后置处理
    getMemberListFun(data, message) {
      var obj = this.getTabsConfig();
      if (this.currentPage == 1) {
        obj.list = [];
      }
      var arr = [...obj.list, ...data];
      //列表赋值
      obj.list = arr;
    },
    //获取参数
    getMemberListData() {
      var obj = {
        currentPage: this.currentPage, //第几页
        pageSize: this.pageSize, //每页展示数量
      };
      return obj;
    },
    //获取会员列表
    getMemberList(url) {
      var obj = this.getMemberListData();
      this.sendQuestion(url, obj, "getMemberListFun");
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        (res) => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this[fun](data, message);
          } else {
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    },
    getStatusColor(item, list) {
      var obj = this.getTabsConfig();
      return this[obj.configKey][item.subStatusp].style;
    },
  },
  data() {
    return {
      activeTab: 0,
      tabList: [
        {
          label: "提案征集提交",
          list: [],
          router: "/solicitingProposals",
          url: "wechatProposalList",
          configKey: "statusConfig",
        },
        {
          label: "提案附议签名",
          list: [],
          router: "/secondedDetails",
          url: "wechatProposalSupportList",
          configKey: "secondedConfig",
        },
      ],
      secondedConfig: {
        0: { title: "未签名", style: "no_submit" },
        1: { title: "已签名", style: "no_submit" },
      },
      statusConfig: {
        0: { title: "未保存", style: "no_submit" },
        1: { title: "待审核", style: "yes_submit" },
        2: { title: "建议", style: "yes_submit" },
        3: { title: "合格", style: "yes_submit" },
        4: { title: "未提交", style: "no_submit" },
        6: { title: "流转中", style: "no_submit" },
      },
      arrList: [], //列表总数
      currentPage: 0, //第几页
      pageSize: 10, //每页个数
    };
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus">
.my_vote_list {
  .card-box {
    position: relative;
    padding: 0;
    border-bottom: 1px solid #F4F4F7;
    margin-bottom: 10px;
    padding: 16px;
    margin-top: 10px;
  }

  .nameStyle {
    width: 70%;
    margin-left: 4px;
    display: inline-block;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    min-width: 0;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    flex: 1;
    line-height: 20px;
  }

  .conterStyle {
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(136, 136, 136, 1);

    > p {
      font-size: 14px;
      line-height: 20px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    > ol, span, ol, li, ul, h1, h2, strong, em {
      display: inline-block;
    }

    > img, br {
      display: none;
    }
  }

  .stateStyle {
    display: flex;
    flex-direction: row-reverse;
  }

  .title-box1 {
    display: flex;
  }

  .titleStyle {
    padding: 4px 7px;
    border-radius: 20px;
    font-size: 11px;
    background: linear-gradient(103deg, rgba(79, 172, 254, 1), rgba(0, 242, 254, 1));
    color: #fff;
    text-align: center;
    display: inline-block;
    margin: auto 0;
  }

  .list-block {
    overflow: scroll;
    margin-top: 0px;
  }

  .list-block-list {
    margin-top: 50px;
  }

  .suggest_color {
    background: linear-gradient(103deg, rgba(69, 209, 172, 1), rgba(39, 189, 186, 1));
  }

  .vote_color {
    background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
  }

  .no_submit {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 75, 75, 1);
  }

  .yes_submit {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(41, 190, 188, 1);
  }
}
</style>